<template>
  <div class="filter-container">
    <FilterList
      ref="filterList"
      class="applicant-list"
      showAISearch
      :candidateList="candidateList"
      :listLoading="listLoading"
      :searchTemplate.sync="searchTemplate"
      :searchTemplateList="searchTemplateList"
      :filterGroupList="filterList"
      :actionList="actionList"
      :addBtnList="addBtnList"
      :operationList="operationList"
      :candidateTotalCount="candidateTotalCount"
      :currentSelectedCount="currentSelectedCount"
      :noAction="noAction"
      :tooltip="tooltip"
      @selectedChange="handleSelectedChange"
      @selectAll="handleSelectAll"
      @search="handelSearch"
      @scrollBottom="handleScrollBottom"
      @orderChange="handleOrderChange"
      @openDetail="handleOpenDetail"
      @candidateStatusClick="handleCandidateStatusClick"
      @createSearchTemplate="handleCreateSearchTemplate"
      @updateSearchTemplate="handleUpdateSearchTemplate"
      @clearSearchTemplate="handleClearSearchTemplate"
      @deleteSearchTemplate="handleDeleteSearchTemplate"
      @selectAllCard="handleSelectAllCard"
      @scrollToTop="handleScrollToTop"
      @onlyMyCandidateChange="onlyMyCandidateChange"
      @expandChange="expandChange"
    >
      <template #tableContainer>
        <TableList
          ref="tableContainer"
          :data="candidateList"
          :cancelSelectedCandidateList="cancelSelectedCandidateList"
          :operationList="operationList"
          :loading="listLoading"
          :isDisabled="noAction"
          :tooltip="tableListTooltip"
          :showAiInterviewFit="isCoachCompany"
          :showAIInterviewScore="hasAIInterviewPermission"
          :showInterviewScore="hasInterviewPermission"
          @selectedChange="handleSelectedChange"
          @selectAll="handleSelectAll"
          @scrollBottom="handleScrollBottom"
          @orderChange="handleOrderChange"
          @openDetail="handleOpenDetail"
          @candidateStatusClick="handleCandidateStatusClick"
          @openDuplicateCandidateDetail="openDuplicateCandidateDetail"
        ></TableList>
      </template>
      <template #cardContainer>
        <CardList
          ref="cardContainer"
          :data="candidateList"
          :operationList="operationList"
          :loading="listLoading"
          :showAiInterviewFit="isCoachCompany"
          :isDisabled="noAction"
          :tooltip="tableListTooltip"
          :showAIInterviewScore="hasAIInterviewPermission"
          :showInterviewScore="hasInterviewPermission"
          @selectedChange="handleSelectedChange"
          @selectAll="handleSelectAll"
          @scrollBottom="handleScrollBottom"
          @orderChange="handleOrderChange"
          @openDetail="handleOpenDetail"
          @candidateStatusClick="handleCandidateStatusClick"
        ></CardList>
      </template>
      <template #filterTip="{filter}">
        <label class="filter-label">{{ filter.label }}</label>
        <i v-auto-tooltip.always="filter.tip" class="filter-tip-icon el-icon-question"></i>
      </template>
    </FilterList>
    <InviteHmRatingDialog
      ref="inviteHmRatingDialog"
      :isAllApplication="ratingDialog.isSelectAll"
      :applicationList="ratingDialog.applicationList"
      :searchParams="searchParams"
      @sent="handleSentHmRatingInvite"
    >
    </InviteHmRatingDialog>
    <InviteInterviewDialog
      ref="inviteInterviewDialog"
      :applicationList="interviewDialog.applicationList"
      :isAllApplication="interviewDialog.isSelectAll"
      :searchParams="searchParams"
      @sent="handleSentInterviewInvite"
    >
    </InviteInterviewDialog>
    <CopyCandidateDialog
      ref="copyCandidateDialog"
      :applicationList="copyCandidateDialog.applicationList"
    ></CopyCandidateDialog>
    <ChangeCandidateStatusDialog
      ref="changeCandidateStatusDialog"
      :isAllApplication="changeCandidateStatusDialog.isSelectAll"
      :applicationList="changeCandidateStatusDialog.applicationList"
      :defaultStatus="changeCandidateStatusDialog.defaultStatus"
      :searchParams="searchParams"
      @success="handleStatusChangedSuccess"
    ></ChangeCandidateStatusDialog>
    <AddTagDialog
      ref="addTagDialog"
      :candidateList="addTagDialog.candidateList"
      :isAllApplication="addTagDialog.isSelectAll"
      :searchParams="searchParams"
      @success="handleStatusChangedSuccess"
    ></AddTagDialog>
    <AddComment
      ref="addCommentDialog"
      showInterviewerCanView
      :jobId="commentDialog.jobId"
      :candidateId="commentDialog.candidateId"
    />
    <ExportCandidateAllInfoDialog
      ref="exportCandidateAllInfoDialog"
      :exportInfo="exportInfo"
      :isOperator="exportCandidateAllInfoDialog.isOperator"
      @save="saveExportCandidateAllInfo"
      @saveOperator="handleSaveOperatorExportCandidateAllInfo"
    ></ExportCandidateAllInfoDialog>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { addI18nProperty, createI18nProperty, getConstantI18nValue, getI18nPropertyValue, isEn } from '@/i18n'
import { REFERRAL_TYPE, READ_STATUS, MUNICIPALITY_CITY, MUNICIPALITY_PROVINCE, GENDER, CONSENT_STATUS, CONTACT_STATUS, APPLICATION_STATUS } from '@/constant/application'
import { DEGREE } from '@/constant/meta'
import FilterList from './filterList/layout.vue'
import ChangeCandidateStatusDialog from './dialog/changeCandidateStatus.vue'
import DateRage from './dateRange.vue'
import RangeSelect from './rangeSelect.vue'
import CopyCandidateDialog from './dialog/copyCandidateDialog.vue'
import InviteHmRatingDialog from './dialog/inviteHmRating.vue'
import InviteInterviewDialog from './dialog/inviteInterview.vue'
import CardList from '../application/universalList/card.vue'
import TableList from './filterList/candidateList.vue'
import AddTagDialog from './dialog/addTagDialog.vue'
import JobSelector from '../components/jobSelector.vue'
import AddComment from '@/views/adminNew/candidate/profile/dialog/addComment.vue'
import ExportCandidateAllInfoDialog from './dialog/exportCandidateAllInfo.vue'
// import TagSelect from '../applicantList/tagSelect.vue'
import {
  RESUME_SDK_TAG_KEYS,
  RESUME_SDK_TAG_TYPES,
  FILTER_GROUP_TYPE,
  CRM_TAG_TYPES,
  COMPANY_LEVEL_ORDER_LIST,
  AI_EXTRA_PARAMS
} from '@/constant/company'
import WorkCompanyName from './workCompanyName.vue'
import applicationApi from '@/api/application'
import { getFileExtension } from '@/utils/oss'

const CANDIDATE_TYPE = {
  EMPLOYEE: 'EMPLOYEE',
  CANDIDATE: 'CANDIDATE'
}

const GRADUATION_YEAR_OPTION_LIST = _.range(moment().year() + 4, 1899, -1)
  .map(year => ({ id: year, i18nName: String(year) }))

const SELECT_ALL_CANDIDATE_LIMIT = {
  ADD_TAG: 20000,
  EXPORT_ORIGINAL_RESUME: 2000,
  EXPORT_ALL_INFO: 60000
}

const PARENT_FIELD_NAME_LIST = {
  CANDIDATE_INFO: 'PersonalInfo',
  APPLICATION_INFO: 'ApplicationInfo',
  FITNESS_INFO: 'FitnessInfo',
  ASSESSMENT_INFO: 'AssessmentInfo',
  INTERN_EXP_INFO: 'InternExperienceInfo',
  WORK_EXP_INFO: 'ExperienceInfo',
  EDUCATION_EXP_INFO: 'EducationInfo',
  ADDITIONAL_INFO: 'AdditionalInfo',
  LANGUAGE_INFO: 'LanguageInfo',
  JOB_SURVEY: 'jobSurveyInfo',
  INTERVIEW_RECORD_INFO: 'interviewRecordInfo',
  CANDIDATE_CONSENT_INFO: 'candidateConsentInfo',
  HM_RATE_INFO: 'hmRateInfo',
  AI_INTERVIEW_INFO: 'aiInterviewInfo'
}

const UNIVERSAL_PAGE_FILTER_KEY = 'universal_page_key'

export default {
  components: {
    FilterList,
    ChangeCandidateStatusDialog,
    CopyCandidateDialog,
    InviteHmRatingDialog,
    InviteInterviewDialog,
    TableList,
    CardList,
    AddTagDialog,
    AddComment,
    ExportCandidateAllInfoDialog
  },
  data () {
    const vm = this
    return {
      i18nPrefix: 'admin.application.applicantList',
      pagination: {
        page: 1,
        pageSize: 20,
        totalPage: 2
      },
      listOrder: {
        prop: 'apply_time',
        order: '-'
      },
      searchTemplate: null,
      searchTemplateList: [],
      savedFilterList: [],
      candidateList: [],
      listLoadingCount: 0,
      isSelectedAllCandidate: false,
      isSelectedAllCardCandidate: false,
      selectedCandidateList: [],
      ratingDialog: {
        isSelectAll: false,
        applicationList: []
      },
      interviewDialog: {
        applicationList: [],
        isSelectAll: false
      },
      copyCandidateDialog: {
        isSelectAll: false,
        applicationList: []
      },
      changeCandidateStatusDialog: {
        isSelectAll: false,
        applicationList: [],
        defaultStatus: null
      },
      addTagDialog: {
        isSelectAll: false,
        candidateList: []
      },
      commentDialog: {
        jobId: null,
        isSelectAll: false,
        candidateId: null
      },
      exportCandidateAllInfoDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateApplyJobIds: []
      },
      exportInfo: {
        loading: false,
        data: [{
          id: 'All',
          get i18nName () {
            return vm.$t('common.label.selectAll')
          },
          children: []
        }]
      },
      isSavingSearchTemplate: false,
      location: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      major: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      school: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      expectedLocation: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      workPositionTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      workIndustryTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      recentWorkIndustryTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      crmTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      skillTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      sharedTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      candidateTotalCount: 0,
      companyPolicyList: [],
      currentSelectedCount: 0,
      search: {},
      searchParams: null,
      listLoading: false,
      pageDataLoader: null,
      cancelSelectedCandidateList: [],
      isNoRefreshSelectedCandidateList: false,
      cvOwnerList: [],
      tagMap: {},
      salaryList: [],
      industryList: [],
      candidateStatusList: [],
      onlyMyCandidate: false,
      metaIndustryList: [],
      metaJobFunctionList: []
    }
  },
  computed: {
    ...mapGetters('account', ['getCurrentAccount', 'accountConfig']),
    hasCopyCandidatePermission () {
      return this.hasAnyPermission(['PREMIUM_COPY_CANDIDATE', 'PERM_HM_APPLY_JOB_FOR_CANDIDATE'])
    },
    hasInviteHMPermission () {
      return this.hasAnyPermission(['PREMIUM_INVITE_HM_REVIEW', 'PERM_INVITE_HM_REVIEW'])
    },
    hasInterviewPermission () {
      return this.hasAnyPermission(['PREMIUM_INTERVIEW_SCHEDULING', 'PERM_HR_INTERVIEW_SCHEDULING'])
    },
    hasMicrositeCampaignPermission () {
      return this.hasAnyPermission('PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT')
    },
    hasCRMTagPermission () {
      return this.hasAnyPermission('PREMIUM_TAG_MANAGEMENT')
    },
    hasParseResumeTagPermission () {
      return this.hasAnyPermission('PREMIUM_CRM_PARSE_RESUME_SDK_TAG')
    },
    hasEmployeeApplyPermission () {
      return this.hasAnyPermission({
        strict: false,
        any: [
          'PREMIUM_REFERRAL_EMPLOYEE_APPLY_INTERNAL_JOB',
          'COMPUTED_COMPANY_HAS_APPLICATION_OR_EMPLOYEE_PULL_INTEGRATION'
        ]
      })
    },
    hasAIInterviewPermission () {
      return this.hasAnyPermission('PREMIUM_AI_INTERVIEW')
    },
    hasAIResumeMatchPermission () {
      return this.hasAnyPermission(['PREMIUM_AI_RESUME_MATCH', 'PERM_HR_VIEW_AI_FIT_SCORE'])
    },
    isCoachCompany () {
      return this.hasAnyPermission('COMPUTED_COMPANY_IS_COACH')
    },
    hasOnlyActionOnMyCandidatePermission () {
      return this.hasAnyPermission('PERM_ONLY_ACTION_ON_MY_CANDIDATE')
    },
    hasAISearchPermission () {
      return this.hasAnyPermission(['PERM_AI_CHAT_SEARCH', 'PREMIUM_AI_CHAT_SEARCH'])
    },
    hasAICandidateSearchFilterPermission () {
      return this.hasAnyPermission('PREMIUM_AI_CANDIDATE_SEARCH_FILTER')
    },
    noAction () {
      return this.hasOnlyActionOnMyCandidatePermission && !this.onlyMyCandidate
    },
    tooltip () {
      return this.noAction ? this.$t(`${this.i18nPrefix}.message.disabledActionCandidate`) : null
    },
    tableListTooltip () {
      return this.noAction ? this.$t(`${this.i18nPrefix}.message.disabledActionCandidateInJob`) : null
    },
    currentAccount () {
      return this.getCurrentAccount
    },
    hasCompanyPolicy () {
      return this.companyPolicyList.length > 0
    },
    actionList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.changeStatus`),
          handler: this.handleChangeStatusAction
        },
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.talentExport`),
          childrenMenuList: [
            {
              label: this.$t(`${this.i18nPrefix}.btn.action.exportAllCandidateInfo`),
              handler: this.handleExportCandidateAllInfo
            },
            {
              label: this.$t('admin.application.candidate.btn.exportOriginResume'),
              handler: this.handleExportOriginalResume
            }
          ]
        },
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteAgreeConsent`),
          handler: this.handleInviteAgreeConsent
        }
      ]
      if (this.hasCopyCandidatePermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.copyCandidates`),
          handler: this.handleCopyCandidateAction
        })
      }
      if (this.hasInviteHMPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteHMRating`),
          handler: this.handleInviteHMRatingAction
        })
      }
      if (this.hasInterviewPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteInterview`),
          handler: this.handleInviteInterviewAction
        })
      }
      if (this.hasCRMTagPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.addTag`),
          handler: this.handleAddTagDialog
        })
      }
      return list
    },
    addBtnList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.btn.uploadCandidate.single`),
          childrenMenuList: [
            {
              label: this.$t('admin.application.candidate.label.switchFullResume'),
              handler: this.handleUploadCandidateAction
            },
            {
              label: this.$t('admin.application.candidate.label.switchMiniResume'),
              handler: this.handleUploadCandidateBasicInfoAction
            }
          ]
        },
        {
          label: this.$t(`${this.i18nPrefix}.btn.uploadCandidate.batch`),
          handler: this.handleBatchUploadCandidateAction
        }
      ]
      if (!this.hasAnyPermission(['PERM_JOB_CANDIDATE_UPLOAD', 'PREMIUM_CANDIDATE_UPLOAD'])) {
        return []
      }
      return list
    },
    operationList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.changeStatus`),
          operator: this.handleChangeStatusOperation
        },
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.talentExport`),
          childrenMenuList: [
            {
              label: this.$t(`${this.i18nPrefix}.btn.action.exportAllCandidateInfo`),
              operator: this.handleExportCandidateAllInfoOperation
            },
            {
              label: this.$t('admin.application.candidate.btn.exportOriginResume'),
              operator: this.handleExportOriginalResumeOperation
            }
          ]
        }
      ]
      if (this.hasCopyCandidatePermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.copyCandidate`),
          operator: this.handleCopyCandidateOperation
        })
      }
      if (this.hasInviteHMPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteHMRating`),
          operator: this.handleInviteHMRatingOperation
        })
      }
      if (this.hasInterviewPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteInterview`),
          operator: this.handleInviteInterviewOperation
        })
      }
      if (this.hasCRMTagPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.addTag`),
          operator: this.handleAddTagOperation
        })
      }
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.action.addComment`),
        operator: this.handleAddCommentOperation
      })
      return list
    },
    filterList () {
      const vm = this
      const filterConfig = this.accountConfig[UNIVERSAL_PAGE_FILTER_KEY]?.filterConfig || {}
      const list = {
        [FILTER_GROUP_TYPE.SOURCE]: {
          title: this.$t(`${this.i18nPrefix}.title.source`), // 分组的标题
          hidden: false, // 是否隐藏
          filterList: {
            // example:
            // gender: { // key，标识
            //   elType: TagSelect, // 必填，元素名称或者组件
            //   label: this.$t(`${this.i18nPrefix}.label.gender`), // 必填
            //   multiple: true,
            //   fetchKey: 'gender',
            //   valueDisplay: { // 在list上面显示filter的值
            //     hidden: false, // 显示
            //     formatter (genderList, filter, filterName, group, groupKey) {
            //       return _.map(genderList, gender => {
            //         const genderLabel = _.find(GENDER, gender)
            //         return {
            //           value: gender,
            //           detail: `${group.label} - ${filter.label}: ${genderLabel}`,
            //           summary: genderLabel
            //         }
            //       })
            //     }
            //   },
            //   props: { // 组件的属性
            //     multiple: true,
            //     tagList: _.map(GENDER, (val, key) => {
            //       return {
            //         label: this.$t(`${this.i18nPrefix}.gender.${key}`),
            //         value: val
            //       }
            //     })
            //   }
            // },
            sourceChannel: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.sourceChannel`),
              optionLabel: 'i18nName',
              optionValue: 'id',
              loader: this.loadSourceChannelList,
              multiple: true,
              optionSearch: true,
              setParam: (params, val) => {
                params.channel_id = _.map(val, 'id').join(',')
              }
            },
            referral: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.referral`),
              optionValue: 'value',
              optionList: _.map(REFERRAL_TYPE, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.referralType.${key}`)),
              multiple: true,
              setParam: (params, val) => {
                params.referral_type = _.map(val, 'value').join(',')
              }
            },
            cvOwner: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.cvOwner`),
              optionLabel: 'name',
              optionValue: 'id',
              optionSearch: true,
              optionGroup: {},
              multiple: true,
              loader: this.loadCvOwnerList,
              setParam: (params, val) => {
                params.cv_owner = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.APPLICATION_DETAIL]: {
          title: this.$t(`${this.i18nPrefix}.title.applicationDetail`),
          filterList: {
            appliedDate: {
              elType: DateRage,
              label: this.$t(`${this.i18nPrefix}.label.appliedDate`),
              multiple: true, // layout组件需要的值
              props: {
                align: 'center',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                disabledFutureDate: true
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.apply_start_time = val[0]
                if (val[1]) {
                  params.apply_end_time = moment(val[1]).add(1, 'days').format('YYYY-MM-DD')
                }
              }
            },
            appliedEntity: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.appliedEntity`),
              loader: this.loadCompanyList,
              multiple: true,
              optionValue: 'id',
              optionLabel: 'i18nName',
              optionSearch: true,
              optionTooltip: true,
              enableExclude: true,
              style: (company) => {
                return { 'padding-left': `${(company.level || 1) * 15}px` }
              },
              props: {
                popperClass: 'entity-popper'
              },
              setParam: (params, val, isExclude) => {
                let paramKey = 'company_ids'
                if (isExclude) {
                  paramKey += '__not'
                }
                params[paramKey] = _.map(val, 'id').join(',')
              }
            },
            appliedJob: {
              elType: JobSelector,
              label: this.$t(`${this.i18nPrefix}.label.appliedJob`),
              multiple: true,
              enableExclude: true,
              props: {
                ref: 'jobSelector',
                showSelectAll: true
              },
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey, filterValues) => {
                  if (!value || value.length < 1) {
                    return
                  }
                  let prefix = ''
                  if (filter.enableExclude) {
                    const isExclude = filterValues?._exclude?.includes(filterName)
                    if (isExclude) {
                      prefix = this.$t(`common.conditionType.${filter.multiple ? 'exclude' : 'notEqual'}`)
                    } else {
                      prefix = this.$t(`common.conditionType.${filter.multiple ? 'include' : 'equal'}`)
                    }
                  }
                  return _.map(value, (item, index) => {
                    return {
                      valueKey: item.id,
                      value: item.id,
                      detail: `${group.title} - ${filter.label}: ${prefix} ${item.i18nName}`,
                      summary: `${prefix} ${item.i18nName}`
                    }
                  })
                }
              },
              cancelSelected: (filterValue, value) => {
                filterValue = _.filter(filterValue, item => item.id !== value)
                return filterValue
              },
              setParam: (params, val, isExclude) => {
                const jobIds = []
                const jobTypes = []
                let onlyMyCandidate = false
                _.forEach(val, job => {
                  if (job.type === 'MY_JOB') {
                    jobTypes.push(job.id)
                  } else {
                    jobIds.push(job.id)
                  }
                })
                if (isExclude) {
                  params.job_id__not = jobIds.join(',')
                  params.job_types__not = jobTypes.join(',')
                } else {
                  params.job_id = jobIds.join(',')
                  params.job_types = jobTypes.join(',')
                  if (_.isEmpty(jobIds) && jobTypes.length === 1 && jobTypes[0] === 'MY_JOB') {
                    onlyMyCandidate = true
                  }
                }
                this.$set(this.$refs.filterList, 'onlyMyCandidate', onlyMyCandidate)
              }
            },
            candidateStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.candidateStatus`),
              optionList: this.candidateStatusList,
              optionLabel: 'i18nName',
              optionValue: 'key',
              multiple: true,
              optionSearch: true,
              enableExclude: true,
              setParam: (params, val, isExclude) => {
                let paramKey = 'candidate_status'
                if (isExclude) {
                  paramKey += '__not'
                }
                params[paramKey] = _.map(val, 'id').join(',')
              }
            },
            applicationStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.applicationStatus`),
              optionValue: 'value',
              optionList: _.map(APPLICATION_STATUS, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.APPLICATION_STATUS.${key}`)),
              setParam: (params, val) => {
                params.application_status = val?.value
              }
            },
            readStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.readStatus`),
              optionValue: 'value',
              optionList: _.map(READ_STATUS, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.READ_STATUS.${key}`)),
              setParam: (params, val) => {
                params.is_viewed = val?.value
              }
            },
            contactStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.contactStatus`),
              optionValue: 'value',
              optionList: _.map(CONTACT_STATUS, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.contactStatus.${key}`)),
              setParam: (params, val) => {
                params.has_contacted = val?.value
              }
            },
            candidateType: {
              hidden: !this.hasEmployeeApplyPermission,
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.candidateType`),
              optionValue: 'value',
              optionList: _.map(CANDIDATE_TYPE, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.candidateType.${key}`)),
              setParam: (params, val) => {
                params.candidate_type = val?.value
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.EMPLOYER]: {
          title: this.$t(`${this.i18nPrefix}.title.employer`),
          filterList: {
            workCompanyName: {
              elType: WorkCompanyName,
              label: null,
              multiple: true,
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey) => {
                  if (!value) {
                    return
                  }
                  const nameList = _.isArray(value.name) ? value.name : [value.name]
                  return _.map(nameList, name => ({
                    valueKey: name,
                    value: name,
                    detail: `${group.title} - ${this.$t(`${this.i18nPrefix}.label.workCompanyName`)}: ${name}`,
                    summary: `${this.$t(`${this.i18nPrefix}.label.workCompanyName`)}: ${name}`
                  }))
                }
              },
              cancelSelected: (filterValue, value) => {
                filterValue.name = null
                filterValue.isLastWork = true
                return filterValue
              },
              setParam: (params, val) => {
                const name = _.isArray(val.name) ? _.join(val.name, ';') : val.name
                if (val.isLastWork) {
                  params.last_work_company_name = name
                } else {
                  params.work_company_name = name
                }
              }
            },
            companyLevelTag: {
              elType: 'el-select',
              labelSlot: 'filterTip',
              tip: this.$t(`${this.i18nPrefix}.tip.companyLevelTag`),
              label: this.$t(`${this.i18nPrefix}.label.companyLevelTag`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE, RESUME_SDK_TAG_KEYS.COMPANY_LEVEL, true)
                const companyLevel = this.tagMap[RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE][RESUME_SDK_TAG_KEYS.COMPANY_LEVEL]
                return _.orderBy(companyLevel, [item => COMPANY_LEVEL_ORDER_LIST.indexOf(item.cn_name)], ['asc'])
              },
              hidden: !this.hasParseResumeTagPermission,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              setParam: (params, val) => {
                params.company_level_tag = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.JOB_TITLE]: {
          title: this.$t(`${this.i18nPrefix}.title.jobTitle`),
          filterList: {
            lastWorkJobName: {
              elType: 'el-input',
              label: this.$t(`${this.i18nPrefix}.label.lastWorkJobName`),
              setParam: (params, val) => {
                params.last_work_job_name = val
              }
            },
            workPositionTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.workPositionTag`),
              optionList: this.tagMap[RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE]?.[RESUME_SDK_TAG_KEYS.POSITION],
              hidden: !this.hasParseResumeTagPermission,
              loader: () => {
                return this.initTagList(this.workPositionTag, 'system', RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE, RESUME_SDK_TAG_KEYS.POSITION)
              },
              initData: () => {
                return this.initSelectData(this.workPositionTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.workPositionTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.workPositionTag, filter)
              },
              props: {
                popperClass: 'work-industry-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.workPositionTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.workPositionTag, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.work_position_tag = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.INDUSTRY]: {
          title: this.$t(`${this.i18nPrefix}.title.industry`),
          filterList: {
            workIndustryTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.workIndustryTag`),
              hidden: this.hasAICandidateSearchFilterPermission || !this.hasParseResumeTagPermission,
              loader: () => {
                return this.initTagList(this.workIndustryTag, 'system', RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE, RESUME_SDK_TAG_KEYS.INDUSTRY)
              },
              initData: () => {
                return this.initSelectData(this.workIndustryTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.workIndustryTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.workIndustryTag, filter)
              },
              props: {
                popperClass: 'work-industry-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.workIndustryTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.workIndustryTag, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.work_industry_tag = _.map(val, 'id').join(',')
              }
            },
            // lastWorkIndustry: {
            //   elType: 'el-select',
            //   label: this.$t(`${this.i18nPrefix}.label.lastWorkIndustry`),
            //   optionList: this.industryList,
            //   optionLabel: 'i18nName',
            //   optionValue: 'id',
            //   multiple: true,
            //   optionSearch: true,
            //   setParam: (params, val) => {
            //     params.last_work_industry = _.map(val, 'id').join(',')
            //   }
            // },
            metaIndustry: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.metaIndustry`),
              hidden: !this.hasAICandidateSearchFilterPermission,
              loader: this.loadMetaIndustryList,
              optionGroup: {
                labelKey: 'i18nName'
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              // labelContainer: {
              //   flex: this.hasAISearchPermission,
              //   showUseAiSwitch: this.hasAISearchPermission
              // }, 暂不需要
              setParam: (params, val) => {
                params.meta_industry_id = _.map(val, 'id').join(',')
              }
            },
            metaJobFunction: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.metaJobFunction`),
              hidden: !this.hasAICandidateSearchFilterPermission,
              loader: this.loadMetaJobFunctionList,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              // labelContainer: {
              //   flex: this.hasAISearchPermission,
              //   showUseAiSwitch: this.hasAISearchPermission
              // }, 暂不需要
              setParam: (params, val) => {
                params.meta_job_function_id = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.SKILL]: {
          title: this.$t(`${this.i18nPrefix}.title.skill`),
          filterList: {
            skillTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.skillTag`),
              hidden: !this.hasParseResumeTagPermission,
              loader: this.resetSkillTag,
              optionSearch: (keywords, loadData, valueList) => {
                return this.loadSkillTagList(keywords, valueList)
              },
              loadTemplate: this.loadSkillTagTemplate,
              filterMethod: this.filterSkillTagMethod,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              selectAll: {
                getOptions: this.getSkillTagSelectAllOptions
              },
              loadMore: (filter) => {
                this.loadMoreData(this.skillTag, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'skill-popper',
                get noDataText () {
                  return vm.getSkillTagNoDataText()
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    this.resetSkillTag(filter)
                  }
                }
              },
              setParam: (params, val) => {
                params.skill_tag = _.map(val, 'id').join(',')
              }
            },
            language: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.language`),
              loader: this.loadLanguageList,
              optionLabel: 'i18nName',
              optionValue: 'id',
              optionSearch: true,
              multiple: true,
              setParam: (params, val) => {
                params.language = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.EDUCATION]: {
          title: this.$t(`${this.i18nPrefix}.title.education`),
          filterList: {
            graduateYear: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.graduateYear`),
              optionList: GRADUATION_YEAR_OPTION_LIST,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              setParam: (params, val) => {
                params.graduate_year = _.map(val, 'id').join(',')
              }
            },
            maxDegree: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.maxDegree`),
              optionList: _.map(DEGREE, (val, key) => createI18nProperty({ id: val }, 'i18nName', `meta.DEGREE.${key}`)),
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              setParam: (params, val) => {
                params.max_degree = _.map(val, 'id').join(',')
              }
            },
            school: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.school`),
              loader: this.initSchoolList,
              multiple: true,
              optionValue: 'id',
              optionLabel: 'i18nName',
              optionSearch: this.loadSchoolList,
              optionTooltip: true,
              loadMore: (filter) => {
                this.loadMoreData(this.school, filter)
              },
              props: {
                popperClass: 'school-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.school)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible) {
                    if (filter) {
                      filter.option.data = []
                    }
                  }
                }
              },
              setParam: (params, val) => {
                params.school_id = _.map(val, 'id').join(',')
              }
            },
            schoolTier: {
              elType: 'el-select',
              labelSlot: 'filterTip',
              tip: this.$t(`${this.i18nPrefix}.tip.schoolTier`),
              label: this.$t(`${this.i18nPrefix}.label.schoolTier`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.EDUCATION, RESUME_SDK_TAG_KEYS.COLLEGE_LEVEL, true)
                return _.reverse(this.tagMap[RESUME_SDK_TAG_TYPES.EDUCATION][RESUME_SDK_TAG_KEYS.COLLEGE_LEVEL])
              },
              hidden: !this.hasParseResumeTagPermission,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              props: { collapseTags: true },
              setParam: (params, val) => {
                params.college_level_tag = _.map(val, 'id').join(',')
              }
            },
            major: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.major`),
              loader: this.initMajorList,
              multiple: true,
              optionValue: 'id',
              optionLabel: 'i18nName',
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.major, keywords, loadData, valueList)
              },
              loadMore: (filter) => {
                this.loadMoreData(this.major, filter)
              },
              props: {
                popperClass: 'major-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.major)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = []
                  }
                }
              },
              setParam: (params, val) => {
                params.major_ids = _.map(val, 'id').join(',')
              }
            },
            foreignEducationExperience: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.foreignEducationExperience`),
              hidden: !this.hasParseResumeTagPermission,
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.EDUCATION, RESUME_SDK_TAG_KEYS.ABROAD_EDU, true)
                return this.tagMap[RESUME_SDK_TAG_TYPES.EDUCATION][RESUME_SDK_TAG_KEYS.ABROAD_EDU]
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              props: { collapseTags: true },
              setParam: (params, val) => {
                params.abroad_edu_tag = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.PROFILE_DETAIL]: {
          title: this.$t(`${this.i18nPrefix}.title.profileDetail`),
          filterList: {
            workYear: {
              elType: RangeSelect,
              label: this.$t(`${this.i18nPrefix}.label.workYear`),
              multiple: true,
              optionSearch: true,
              props: {
                clearable: true,
                optionList: _.chain(0).range(16).map(year => {
                  return {
                    label: year >= 15 ? '15+' : year,
                    value: year
                  }
                }).value()
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.work_year_min = val[0]
                params.work_year_max = val[1]
              }
            },
            gender: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.gender`),
              multiple: true,
              optionValue: 'value',
              optionList: _.map(GENDER, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.gender.${key}`)),
              setParam: (params, val) => {
                params.gender = _.map(val, 'value').join(',')
              }
            },
            age: {
              elType: RangeSelect,
              label: this.$t(`${this.i18nPrefix}.label.age`),
              multiple: true,
              props: {
                clearable: true,
                optionList: _.chain(18).range(100).map(age => {
                  return {
                    label: age >= 100 ? '100+' : age,
                    value: age
                  }
                }).value()
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.age_min = val[0]
                params.age_max = val[1]
              }
            },
            location: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.location`),
              optionLabel: 'locationName',
              optionValue: 'id',
              multiple: true,
              optionSearch: this.loadLocationList,
              loadTemplate: this.loadLocationTemplate,
              loader: this.getLocationList,
              filterMethod: this.filterLocationMethod,
              loadMore: (filter) => {
                this.loadMoreData(this.location, filter)
              },
              props: {
                popperClass: 'location-dropdown',
                get noDataText () {
                  return vm.getNoDataText(vm.location)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible) {
                    if (filter) {
                      filter.option.data = []
                    }
                  }
                }
              },
              setParam: (params, val) => {
                const group = _.groupBy(val, 'type_code')
                // 处理直辖市
                const municipalityCityIds = []
                _.forEach(group.district, location => {
                  const cityName = _.findKey(MUNICIPALITY_PROVINCE, city => city === location.id)
                  if (cityName) {
                    municipalityCityIds.push(MUNICIPALITY_CITY[cityName])
                  }
                })

                params.location_country_id = _.map(group.country, 'id').join(',')
                params.location_province_id = _.map(group.district, 'id').join(',')
                params.location_city_id = [..._.map(group.city, 'id'), ...municipalityCityIds].join(',')
              }
            },
            expectedLocation: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.expectedLocation`),
              optionLabel: 'locationName',
              optionValue: 'id',
              multiple: true,
              optionSearch: this.loadExpectedLocationList,
              loadTemplate: this.loadExpectedLocationTemplate,
              loader: this.getExpectedLocationList,
              loadMore: (filter) => {
                this.loadMoreData(this.expectedLocation, filter)
              },
              props: {
                popperClass: 'location-dropdown',
                get noDataText () {
                  return vm.getNoDataText(vm.expectedLocation)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible) {
                    if (filter) {
                      filter.option.data = []
                    }
                  }
                }
              },
              setParam: (params, val) => {
                const group = _.groupBy(val, 'type_code')
                // 处理直辖市
                const municipalityCityIds = []
                _.forEach(group.district, location => {
                  const cityName = _.findKey(MUNICIPALITY_PROVINCE, city => city === location.id)
                  if (cityName) {
                    municipalityCityIds.push(MUNICIPALITY_CITY[cityName])
                  }
                })

                params.expected_country_id = _.map(group.country, 'id').join(',')
                params.expected_province_id = _.map(group.district, 'id').join(',')
                params.expected_city_id = [..._.map(group.city, 'id'), ...municipalityCityIds].join(',')
              }
            },
            expectedSalary: {
              elType: RangeSelect,
              label: this.$t(`${this.i18nPrefix}.label.expectedSalary`),
              multiple: true,
              optionSearch: true,
              props: {
                clearable: true,
                optionList: this.salaryList,
                optionLabelKey: 'name',
                optionValueKey: 'name'
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.salary_min = val[0]
                params.salary_max = val[1]
              }
            },
            consentStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.consentStatus`),
              multiple: true,
              hidden: !this.hasCompanyPolicy,
              optionList: this.companyPolicyList,
              optionLabel: 'i18nName',
              optionValue: 'value',
              optionSearch: true,
              optionTooltip: true,
              optionGroup: {
                labelKey: 'i18nName',
                valueKey: 'value',
                dataKey: 'status_list'
              },
              props: {
                popperClass: 'consent-info-popper'
              },
              valueDisplay: {
                formatter: this.formatConsentFilterDisplayValue
              },
              cancelSelected: (filterValue, value) => {
                filterValue = _.filter(filterValue, item => item.value !== value)
                return filterValue
              },
              setParam: (params, val) => {
                const option = []
                _.forEach(val, policy => {
                  option.push(policy.value)
                })
                params.consent_status = option.join(',')
              }
            },
            hasPhone: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.hasPhone`),
              optionList: [
                { get label () { return vm.$t('common.label.yes') }, value: '1' },
                { get label () { return vm.$t('common.label.no') }, value: '0' }
              ],
              optionLabel: 'label',
              optionValue: 'value',
              setParam: (params, val) => {
                params.has_phone = val.value
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.CRM_TAG]: {
          title: this.$t(`${this.i18nPrefix}.title.crmTag`),
          filterList: {
            crmTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.crmTag`),
              hidden: !this.hasCRMTagPermission,
              loader: () => {
                return this.initCRMTagList(this.crmTag)
              },
              initData: () => {
                return this.initSelectData(this.crmTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.crmTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              enableExclude: true,
              loadMore: (filter) => {
                this.loadMoreData(this.crmTag, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'shared-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.crmTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.crmTag, 2)
                  }
                }
              },
              setParam: (params, val, isExclude) => {
                let paramKey = 'tag_id'
                if (isExclude) {
                  paramKey += '__not'
                }
                params[paramKey] = _.map(val, 'id').join(',')
                params.is_match_all_tag = '0'
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.CANDIDATE_BEHAVIOR]: {
          title: this.$t(`${this.i18nPrefix}.title.candidateBehavior`),
          filterList: {
            sharedTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.sharedTag`),
              hidden: !this.hasCRMTagPermission,
              loader: () => {
                return this.initTagList(this.sharedTag, 'system', CRM_TAG_TYPES.SHARED)
              },
              initData: () => {
                return this.initSelectData(this.sharedTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.sharedTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.sharedTag, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'shared-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.sharedTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.sharedTag, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.crm_shared_tag = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.OTHER_FACTOR]: {
          title: this.$t(`${this.i18nPrefix}.title.otherFactors`),
          filterList: {
            stabilityTag: {
              elType: 'el-select',
              labelSlot: 'filterTip',
              tip: this.$t(`${this.i18nPrefix}.tip.stabilityTag`),
              label: this.$t(`${this.i18nPrefix}.label.stabilityTag`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.STABILITY, null, true)
                return _.orderBy(this.tagMap[RESUME_SDK_TAG_TYPES.STABILITY], ['order'], ['asc'])
              },
              hidden: !this.hasParseResumeTagPermission,
              multiple: true,
              optionLabel: 'i18nName',
              optionValue: 'id',
              props: {
                collapseTags: true,
                filterable: true
              },
              setParam: (params, val) => {
                params.stability_tag = _.map(val, item => item.id).join(',')
              }
            },
            riskTag: {
              elType: 'el-select',
              labelSlot: 'filterTip',
              tip: this.$t(`${this.i18nPrefix}.tip.riskTag`),
              label: this.$t(`${this.i18nPrefix}.label.riskTag`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.RISKS, null, true)
                return this.tagMap[RESUME_SDK_TAG_TYPES.RISKS]
              },
              hidden: !this.hasParseResumeTagPermission,
              multiple: true,
              optionLabel: 'i18nName',
              optionValue: 'id',
              props: {
                collapseTags: true,
                filterable: true
              },
              enableExclude: true,
              defaultExclude: true,
              setParam: (params, val, isExclude) => {
                let paramKey = 'risks_tag'
                if (isExclude) {
                  paramKey += '__not'
                }
                params[paramKey] = _.map(val, item => item.id).join(',')
              }
            }
          }
        }
      }
      _.forEach(list, (value, key) => {
        value.defaultExpand = filterConfig[key] || false
      })

      return list
    },
    candidateListLength () {
      return this.candidateList.length
    },
    selectAllIsIndeterminate () {
      if (this.currentSelectedCount && (this.currentSelectedCount !== this.candidateTotalCount)) {
        return true
      }
      return false
    }
  },
  created () {
    this.pageDataLoader = this.initPageData()
  },
  mounted () {
    this.pageDataLoader.finally(() => {
      this.$eventBus.$emit('showLoading', false)
    }).then(() => {
      const onlyUseStatus = this.$route.query.only_use_status === '1'
      const candidateStatus = this.$route.query.candidate_status
      let appliedDate
      let readStatus
      let companyId
      let appliedJob
      if (!onlyUseStatus) {
        appliedDate = this.$route.query.applied_date || moment().subtract(1, 'years').format('YYYY-MM-DD')
        readStatus = this.$route.query.read_status
        companyId = this.$route.query.company_id
        let showMyJob = false
        if (_.has(this.$route.query, 'my_job')) {
          showMyJob = this.$route.query.my_job === '1'
        } else {
          showMyJob = this.hasOnlyActionOnMyCandidatePermission
        }
        appliedJob = showMyJob
          ? [createI18nProperty({
              id: 'MY_JOB',
              type: 'MY_JOB',
              leaf: true
            }, 'i18nName', `${this.i18nPrefix}.label.myJob`)]
          : null
      }
      this.listLoading = true
      const applicationDetailSearch = {
        candidateStatus: candidateStatus ? candidateStatus.split(',') : ['Disqualified'],
        readStatus: readStatus?.split(','),
        appliedJob: appliedJob,
        appliedEntity: companyId,
        appliedDate: appliedDate && appliedDate.split(',')
      }
      if (!candidateStatus) {
        applicationDetailSearch._exclude = ['candidateStatus']
      }
      const search = {
        [FILTER_GROUP_TYPE.APPLICATION_DETAIL]: applicationDetailSearch
      }
      return this.$refs.filterList.resetSearch({ search }, true)
    }).then((search) => {
      if (this.$refs.filterList) {
        this.$refs.filterList.noTriggerSearch = false
      }
      return this.handelSearch(search)
    }).finally(() => {
      this.listLoading = false
    })
  },
  methods: {
    ...mapActions('sourceCode', ['getSourceChannelList']),
    ...mapActions('worldLocation', ['getWorldLocationList']),
    ...mapActions('application', [
      'getLanguageList',
      'getSchoolList',
      'getCompanyApplicationList',
      'getExportJobApplicationExcelFieldInfo',
      'createExportUniversalApplicationExcelInfoTask',
      'getMajorList',
      'getSalaryList',
      'getIndustryList',
      'exportOriginalResume'
    ]),
    ...mapActions('candidateStatus', ['getCandidateStatusList']),
    ...mapActions('company', ['getCvOwnerList', 'getCompanyChildrenTree']),
    ...mapActions('account', [
      'getAccountPageConfigList',
      'createAccountPageConfig',
      'updateAccountPageConfig',
      'deleteAccountPageConfig',
      'setAccountConfig'
    ]),
    ...mapActions('agreement', ['getCompanyPolicyItemList', 'inviteCandidateAgreeConsent']),
    ...mapActions('crm', ['searchTag']),
    ...mapActions('metaInfo', ['getMetaIndustryList', 'getMetaJobFunctionList']),
    async loadExportJobApplicationExcelFields () {
      if (this.loading) {
        return
      }
      this.loading = true
      const resp = await this.getExportJobApplicationExcelFieldInfo()
      if (resp) {
        const parentGroupField = _.groupBy(resp, 'parent_field')
        const fieldList = []
        _.forEach(PARENT_FIELD_NAME_LIST, (value, key) => {
          const childrenFields = parentGroupField[key]
          _.forEach(childrenFields, field => {
            addI18nProperty(field, 'i18nName', 'cn_name', 'en_name')
          })
          let fieldNote = null
          if (childrenFields.length === 1) {
            const childrenField = childrenFields[0]
            fieldNote = {
              i18nName: this.$t(`${this.i18nPrefix}.PARENT_FIELD_NAME_LIST.${value}`),
              id: key,
              children: [],
              col_index: childrenField.col_index,
              data_type: childrenField.data_type,
              header_value: childrenField.i18nName,
              cn_name: childrenField.cn_name,
              en_name: childrenField.en_name
            }
          } else {
            fieldNote = {
              i18nName: this.$t(`${this.i18nPrefix}.PARENT_FIELD_NAME_LIST.${value}`),
              id: key,
              children: childrenFields
            }
          }
          if (fieldNote) {
            fieldList.push(fieldNote)
          }
        })
        this.exportInfo.data[0].children = fieldList
      }
      this.loading = false
    },
    formatRangeFilterDisplayValue (value, filter, filterName, group, groupKey) {
      const displayValue = {
        valueKey: -1,
        value: null,
        summary: null,
        get detail () {
          return `${group.title} - ${this.summary}`
        }
      }
      const startVal = value[0]
      const endVal = value[1]
      const nilVal = [null, undefined, '']
      if (!nilVal.includes(startVal) && !nilVal.includes(endVal)) {
        displayValue.valueKey = -1
        displayValue.value = value
        displayValue.summary = `${filter.label}: ${startVal} ~ ${endVal}`
      } else if (!nilVal.includes(startVal)) {
        displayValue.valueKey = 0
        displayValue.value = value
        displayValue.summary = `${filter.label}: > ${startVal}`
      } else if (!nilVal.includes(endVal)) {
        displayValue.valueKey = 1
        displayValue.value = value
        displayValue.summary = `${filter.label}: < ${endVal}`
      }
      return displayValue
    },
    cancelRangeFilterValue (filterValue, value, valueKey) {
      if (valueKey < 0) {
        return []
      } else {
        return _.map(filterValue, (val, index) => valueKey === index ? null : val)
      }
    },
    formatConsentFilterDisplayValue (value, filter, filterName, group, groupKey) {
      const displayValueList = []
      _.forEach(value, option => {
        const displayValue = {
          valueKey: null,
          value: option.value,
          summary: null,
          detail: null
        }
        const optionValue = option.value + ''
        const policyItemId = parseInt(optionValue.split('-')[0])
        const policyItem = _.find(this.companyPolicyList, policy => policy.id === policyItemId)
        displayValue.summary = option.i18nName
        displayValue.detail = `${group.title}-${policyItem.i18nName}`
        displayValueList.push(displayValue)
      })
      return displayValueList
    },
    handleSelectedChange (val) {
      this.selectedCandidateList = val
      const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
      if (val.length !== this.candidateList.length) {
        this.isSelectedAllCandidate = false
        this.isSelectedAllCardCandidate = false
        this.isClickSelectAll = false
      }
      if (this.isSelectedAllCandidate && this.isSelectedAllCardCandidate) {
        this.currentSelectedCount = this.candidateTotalCount - hiddenCandidateList.length
      } else if (this.isSelectedAllCandidate || this.isSelectedAllCardCandidate) {
        this.cancelSelectedCandidateList = []
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(val, candidate)) {
            this.cancelSelectedCandidateList.push(candidate)
          }
        })
        const cancelSelectCount = this.candidateList.length - val.length
        this.currentSelectedCount = this.candidateList.length - cancelSelectCount
      } else if (this.isClickSelectAll) {
        const cancelSelectCount = this.candidateList.length - val.length
        this.currentSelectedCount = this.candidateTotalCount - cancelSelectCount
        this.cancelSelectedCandidateList = []
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(val, candidate)) {
            this.cancelSelectedCandidateList.push(candidate)
          }
        })
      } else {
        this.currentSelectedCount = val.length
        this.isNoRefreshSelectedCandidateList = true
      }
      const cancelCandidateIds = _.map(this.cancelSelectedCandidateList, candidate => candidate.candidate.id)
      this.searchParams.cancel_candidate_ids = cancelCandidateIds.join(',')
    },
    handleSelectAllCard (selected) {
      if (selected) {
        const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
        _.forEach(this.candidateList, candidate => {
          if (!candidate.is_agency_uploaded_and_hid) {
            candidate.selected = true
          }
        })
        this.isSelectedAllCandidate = true
        this.isSelectedAllCardCandidate = true
        this.currentSelectedCount = this.candidateTotalCount - hiddenCandidateList.length
        this.isClickSelectAll = true
        this.isNoRefreshSelectedCandidateList = false
      } else {
        _.forEach(this.candidateList, candidate => {
          candidate.selected = false
        })
        this.isSelectedAllCandidate = false
        this.isSelectedAllCardCandidate = false
        this.currentSelectedCount = 0
        this.isClickSelectAll = false
      }
      this.cancelSelectedCandidateList = []
    },
    handleSelectAll (selected) {
      const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
      this.isSelectedAllCandidate = selected.length > 0
      this.isClickSelectAll = selected.length > 0
      this.isNoRefreshSelectedCandidateList = !this.isSelectedAllCandidate
      this.currentSelectedCount = this.isSelectedAllCandidate ? this.candidateTotalCount - hiddenCandidateList.length : 0
      this.cancelSelectedCandidateList = []
    },
    handleUploadCandidateAction () {
      const back = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/job/-1/add?back=${back}&is_basic_info=0`)
    },
    handleUploadCandidateBasicInfoAction () {
      const back = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/job/-1/add?back=${back}&is_basic_info=1`)
    },
    handleBatchUploadCandidateAction () {
      window.open('/v-admin/application/-1/batch-upload/uploader?from_applicant=1')
    },
    hasSelected () {
      if (!this.isSelectedAllCandidate && this.selectedCandidateList.length < 1) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAtLeastCandidate`))
        return false
      }
      return true
    },
    handleChangeStatusAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.changeCandidateStatusDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.changeCandidateStatusDialog.showDialog()
    },
    handleCopyCandidateAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.copyCandidateDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.copyCandidateDialog.showDialog()
    },
    handleInviteHMRatingAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const jobCount = Object.keys(_.groupBy(this.selectedCandidateList, 'job.id')).length
      if (jobCount > 1) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.onlySameJobCandidatesCanInvite`))
        return
      }
      this.ratingDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.inviteHmRatingDialog.showDialog()
    },
    handleSentHmRatingInvite (inviteResult) {
      const changedCandidateIds = inviteResult.changed_candidate_ids
      const applicationList = this.ratingDialog.applicationList
      _.forEach(applicationList, application => {
        if (changedCandidateIds.includes(application.candidate.id)) {
          application.status = addI18nProperty(inviteResult.candidate_status, 'i18nName', 'name_cn', 'name_en')
        }
      })
      this.handleStatusChangedSuccess()
    },
    handleInviteInterviewAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const jobCount = Object.keys(_.groupBy(this.selectedCandidateList, 'job.id')).length
      if (this.isSelectedAllCandidate || jobCount > 1) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.onlySameJobCandidatesCanInvite`))
        return
      }
      this.interviewDialog = {
        applicationList: this.selectedCandidateList,
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
      }
      this.$refs.inviteInterviewDialog.showDialog()
    },
    handleSentInterviewInvite (inviteResult) {
      const changedCandidateIds = inviteResult.changed_candidate_ids
      const applicationList = this.interviewDialog.applicationList
      _.forEach(applicationList, application => {
        if (changedCandidateIds.includes(application.candidate.id)) {
          application.status = addI18nProperty(inviteResult.candidate_status, 'i18nName', 'name_cn', 'name_en')
        }
      })

      this.handleStatusChangedSuccess()
    },
    handleAddTagDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      this.addTagDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        candidateList: candidates
      }
      if (candidates.length > SELECT_ALL_CANDIDATE_LIMIT.ADD_TAG || (this.isSelectedAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.ADD_TAG)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.ADD_TAG }))
        return
      }
      this.$refs.addTagDialog.showDialog()
    },
    handleExportCandidateAllInfo () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidateApplyJobIds = []
      _.forEach(this.selectedCandidateList, application => {
        candidateApplyJobIds.push(application.candidate_apply_job_id)
      })
      this.exportCandidateAllInfoDialog = {
        isSelectAll: this.isSelectedAllCandidate,
        candidateApplyJobIds: candidateApplyJobIds
      }
      if (candidateApplyJobIds.length > SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ALL_INFO || (this.isSelectedAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ALL_INFO)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ALL_INFO }))
        return
      }
      this.loadExportJobApplicationExcelFields()
      this.$refs.exportCandidateAllInfoDialog.showDialog()
    },
    async handleInviteAgreeConsent () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.$eventBus.$emit('showLoading', true)
      const data = {
        is_batch: true,
        is_all_application: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        application_ids: _.map(this.selectedCandidateList, 'id'),
        search_params: this.searchParams
      }
      try {
        const resp = await this.inviteCandidateAgreeConsent(data)
        if (resp) {
          this.$message({
            type: 'success',
            message: this.$t(`${this.i18nPrefix}.message.inviteAgreeConsent.success`)
          })
        } else {
          this.$message({
            type: 'error',
            message: this.$t(`${this.i18nPrefix}.message.inviteAgreeConsent.fail`)
          })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async saveExportCandidateAllInfo (optionInfo, callback) {
      const params = {
        field_list: optionInfo,
        select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        candidate_apply_job_ids: _.map(this.selectedCandidateList, item => item.candidate_apply_job_id),
        search_params: this.searchParams,
        export_from_universal_applicant_list: true
      }
      let resp = null
      try {
        resp = await this.createExportUniversalApplicationExcelInfoTask(params)
        this.$message.success({
          dangerouslyUseHTMLString: true,
          message: this.$t(`${this.i18nPrefix}.message.ExcelDownloadTip`),
          showClose: true,
          duration: 10 * 1000 // 10s
        })
      } finally {
        callback(resp)
      }
    },
    handleExportCandidateAllInfoOperation (rowData) {
      this.exportCandidateAllInfoDialog = {
        isSelectAll: false,
        isOperator: true,
        candidateApplyJobIds: [rowData.candidate_apply_job_id]
      }
      this.loadExportJobApplicationExcelFields()
      this.$refs.exportCandidateAllInfoDialog.showDialog()
    },
    async handleSaveOperatorExportCandidateAllInfo (optionInfo, callback) {
      const params = {
        field_list: optionInfo,
        select_all_candidate: false,
        candidate_apply_job_ids: this.exportCandidateAllInfoDialog.candidateApplyJobIds,
        search_params: this.searchParams,
        export_from_universal_applicant_list: true
      }
      let resp = null
      try {
        resp = await this.createExportUniversalApplicationExcelInfoTask(params)
        this.$message.success({
          dangerouslyUseHTMLString: true,
          message: this.$t(`${this.i18nPrefix}.message.ExcelDownloadTip`),
          showClose: true,
          duration: 10 * 1000 // 10s
        })
      } finally {
        callback(resp)
      }
    },
    handleAddTagOperation (rowData) {
      this.addTagDialog = {
        isSelectAll: false,
        candidateList: [rowData.candidate.id]
      }
      this.$refs.addTagDialog.showDialog()
    },
    handleChangeStatusOperation (rowData) {
      this.changeCandidateStatusDialog = {
        isSelectAll: false,
        applicationList: [rowData],
        defaultStatus: rowData.status.key
      }
      this.$refs.changeCandidateStatusDialog.showDialog()
    },
    handleCopyCandidateOperation (rowData) {
      this.copyCandidateDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.copyCandidateDialog.showDialog()
    },
    handleInviteHMRatingOperation (rowData) {
      this.ratingDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.inviteHmRatingDialog.showDialog()
    },
    handleInviteInterviewOperation (rowData) {
      this.interviewDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.inviteInterviewDialog.showDialog()
    },
    async handleExportOriginalResume () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const isSelectAllApplication = this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
      const candidateApplyJobIds = _.map(this.selectedCandidateList, 'candidate_apply_job_id')
      if (!candidateApplyJobIds.length) {
        this.$message.warning(this.$t('common.label.noData'))
        return
      }
      if (candidateApplyJobIds.length > SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ORIGINAL_RESUME || (isSelectAllApplication && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ORIGINAL_RESUME)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ORIGINAL_RESUME }))
        return
      }

      if (candidateApplyJobIds.length === 1) {
        // 单个导出: 直接下载
        await this.downloadSingleOriginalResume(this.selectedCandidateList[0])
      } else {
        // 批量导出: 调用后端 API，打包发邮件
        await this.exportBatchOriginalResume(candidateApplyJobIds)
      }
    },
    async handleExportOriginalResumeOperation (rowData) {
      await this.downloadSingleOriginalResume(rowData)
    },
    async downloadSingleOriginalResume (rowData) {
      if (!rowData.candidate.resume_path) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.noOriginalResume`))
        return
      }
      try {
        this.$eventBus.$emit('showLoading', true)
        if (!rowData || rowData.is_agency_uploaded_and_hid || !rowData.job || !rowData.candidate || !rowData.job.id || !rowData.candidate.id) {
          this.$message.error(this.$t('common.message.downloadFailed'))
          return
        }

        const companyName = getI18nPropertyValue(rowData.job.company, 'cn_name', 'name')
        const jobName = getI18nPropertyValue(rowData.job, 'cn_title', 'title')
        const fileName = `${companyName}_${jobName}_${rowData.candidate.name}_${rowData.candidate.id}_${moment().format('YYYYMMDD')}`
        const ext = getFileExtension(rowData.candidate.resume_path)
        const downloadFileName = ext ? `${fileName}.${ext}` : fileName
        const result = await applicationApi.getResumeDownloadUrl(rowData.job.id, rowData.candidate.id, { file_name: downloadFileName })
        if (!result || !result.url) {
          this.$message.error(this.$t('common.message.downloadFailed'))
          return
        }

        window.location.href = result.url
      } catch (error) {
        this.$message.error(this.$t('common.message.downloadFailed'))
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async exportBatchOriginalResume (candidateApplyJobIds) {
      try {
        const selectAllCandidate = this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
        const resp = await this.exportOriginalResume({
          select_all_application: selectAllCandidate,
          select_all_candidate: selectAllCandidate,
          search_params: this.searchParams,
          application_ids: candidateApplyJobIds
        })

        if (resp && resp.task_id) {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.exportOriginalResumeTaskCreated`))
        }
      } catch (error) {
        this.$message.error(this.$t('common.message.exportFailed'))
      }
    },
    handleAddCommentOperation (rowData) {
      this.commentDialog = {
        jobId: rowData.job.id,
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        candidateId: rowData.candidate.id
      }
      this.$refs.addCommentDialog.openDialog()
    },
    async loadSourceChannelList () {
      const params = {
        status: 1,
        global_channel: 1
      }
      const resp = await this.getSourceChannelList(params)
      if (resp) {
        const weChatChannel = createI18nProperty({ id: 0 }, 'i18nName', `${this.i18nPrefix}.label.weChatChannelName`)
        const channelList = _.map(resp.result, item => addI18nProperty(item, 'i18nName', 'cn_name', 'name'))
        channelList.splice(0, 0, weChatChannel)
        this.sourceChannelList = channelList
      }
      return this.sourceChannelList
    },
    async loadCandidateStatusList () {
      const resp = await this.getCandidateStatusList({ is_all: 1 })
      if (resp) {
        this.candidateStatusList = _.map(resp, item => addI18nProperty(item, 'i18nName', 'name_cn', 'name_en'))
      }
      return this.candidateStatusList
    },
    async filterLocationMethod (queryValue, filter) {
      let filteredList = []
      _.chain(queryValue).reverse().filter().forEach((query, index) => {
        if (_.isEmpty(filteredList)) {
          filteredList = _.filter(this.location.data, location => {
            return _.includes(location.cn_name, query)
          })
        } else {
          const tempList = _.filter(filteredList, location => {
            let parent = location.parent
            if (index === 2) {
              parent = parent?.parent
            }
            if (parent) {
              return _.chain(parent.searchTextList)
                .map(item => _.toUpper(item))
                .some(item => _.includes(item, _.toUpper(query)))
            }
            return true
          })
          if (!_.isEmpty(tempList)) {
            filteredList = tempList
          }
        }
      }).value()
      return filteredList
    },
    async getLocationList () {
      if (this.location.hasLoad) {
        return
      }
      if (this.expectedLocation.hasLoad) {
        this.location = this.expectedLocation
      } else {
        this.location.hasLoad = true
        const resp = await this.getWorldLocationList()
        if (!resp) {
          return
        }
        this.location.data = _.map(resp, location => {
          addI18nProperty(location, 'i18nName', 'cn_name', 'name')
          location.searchTextList = []
          location.searchTextList.push(location.name, location.cn_name, location.pinyin_name)
          if (location.parent_id) {
            const locationInfo = _.find(resp, item => item.id === location.parent_id)
            location.parent = locationInfo
            location.searchTextList.push(locationInfo.name, locationInfo.cn_name, locationInfo.pinyin_name)
          }
          // 处理四个直辖市, 不出现在下拉列表中
          if (_.findKey(MUNICIPALITY_CITY, city => city === location.id)) {
            location.searchTextList = null
          }
          if (location.type_code === 'region') {
            location.searchTextList = null
          }
          const nameList = []
          if (location.parent) {
            this.getParentLocation(location, nameList)
          }
          const searchLabelList = [location.cn_name]
          if (location.parent) {
            this.getParentLocationCnName(location, searchLabelList)
          }
          location.searchLabelList = _.reverse(searchLabelList)
          location.locationName = _.chain([location.i18nName, ...nameList]).filter().join(' - ').value()
          return location
        })
      }
      return this.location.data
    },
    async loadLocationList (keywords, loadData, valueList) {
      this.location.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      const filteredList = _.filter(this.location.data, location => {
        if (valueList?.length > 0) {
          return _.includes(valueList, location.id)
        } else {
          const keywordsList = _.map(location.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      this.location.page = 1
      this.location.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, this.location.pageSize)
    },
    getParentLocation (location, nameList) {
      const parent = location.parent
      if (parent) {
        if (parent.searchTextList) {
          nameList.push(parent.i18nName)
        }
        if (parent.parent_id) {
          this.getParentLocation(parent, nameList)
        }
      }
    },
    getParentLocationCnName (location, nameList) {
      const parent = location.parent
      if (parent) {
        nameList.push(parent.cn_name)
        if (parent.parent_id) {
          this.getParentLocationCnName(parent, nameList)
        }
      }
    },
    async loadLocationTemplate (valueList, filter, formattedFilterValues) {
      if (valueList?.length < 1) {
        return []
      }
      const locationList = await this.loadLocationList(null, null, valueList)
      if (locationList.length > 0) {
        filter.option.data = locationList
        formattedFilterValues.location = locationList
      }
    },
    async initSchoolList () {
      if (this.school.hasLoad) {
        return
      }
      this.school.hasLoad = true
      const resp = await this.getSchoolList()
      if (!resp) {
        return
      }
      this.school.data = _.map(resp.schools, school => {
        addI18nProperty(school, 'i18nName', 'cn_name', 'name')
        school.searchTextList = []
        school.searchTextList.push(school.name, school.cn_name, school.pinyin_name)
        return school
      })
      return this.school.data
    },
    async loadLanguageList () {
      const resp = await this.getLanguageList()
      if (resp) {
        this.languageList = _.map(resp.languages, item => addI18nProperty(item, 'i18nName', 'cn_name', 'en_name'))
      }
      return this.languageList
    },
    async loadSchoolList (keywords, loadData, valueList) {
      this.school.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      const filteredList = _.filter(this.school.data, school => {
        if (valueList?.length > 0) {
          return _.includes(valueList, school.id)
        } else {
          const keywordsList = _.map(school.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      this.school.page = 1
      this.school.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, this.school.pageSize)
    },
    async initTagList (tag, category, type, key) {
      if (tag.hasLoad) {
        return
      }
      tag.hasLoad = true
      if (key) {
        await this.loadTagList(category, type, key, true)
        tag.data = this.tagMap[type][key]
      } else {
        await this.loadTagList(category, type)
        tag.data = this.tagMap[type]
      }
      return tag.data
    },
    resetSkillTag (filter) {
      this.skillTag.keywords = null
      this.skillTag.currentData = []
      this.skillTag.page = 1
      if (filter?.option) {
        filter.option.data = []
      }
      return []
    },
    async initSkillTagList () {
      if (!this.skillTag.hasLoad) {
        const skillTagKey = [RESUME_SDK_TAG_KEYS.JOB_SKILL, RESUME_SDK_TAG_KEYS.SOFT_SKILL].join(',')
        this.skillTag.hasLoad = true
        await this.loadTagList('system', RESUME_SDK_TAG_TYPES.SKILLS, skillTagKey, true)
        this.skillTag.data = this.tagMap[RESUME_SDK_TAG_TYPES.SKILLS]?.[skillTagKey] || []
      }
      return this.skillTag.data
    },
    getSkillTagNoDataText () {
      if (!_.trim(this.skillTag.keywords)) {
        return this.$t(`${this.i18nPrefix}.label.pleaseStartTyping`)
      }
      return this.$t('el.select.noMatch')
    },
    getSkillTagSelectAllOptions (filter) {
      if (!_.trim(this.skillTag.keywords) || !filter?.option?.data?.length) {
        return []
      }
      return this.skillTag.currentData || []
    },
    async loadSkillTagList (keywords, valueList) {
      this.skillTag.keywords = keywords
      if (valueList?.length > 0) {
        return this.loadSkillTagSelectedList(valueList)
      }
      if (!_.trim(keywords)) {
        this.skillTag.currentData = []
        this.skillTag.page = 1
        return []
      }
      await this.initSkillTagList()
      return this.searchItemList(this.skillTag, keywords, null, valueList)
    },
    async loadSkillTagSelectedList (valueList) {
      await this.initSkillTagList()
      if (!valueList?.length) {
        return []
      }
      const selectedList = _.filter(this.skillTag.data || [], tag => _.includes(valueList, tag.id))
      this.skillTag.currentData = selectedList
      return selectedList
    },
    async loadSkillTagTemplate (valueList, filter, formattedFilterValues) {
      const selectedList = await this.loadSkillTagSelectedList(valueList)
      filter.option.data = selectedList
      formattedFilterValues.skillTag = selectedList
    },
    async filterSkillTagMethod (value, filter) {
      const selectedList = await this.loadSkillTagSelectedList([value])
      const optionList = _.uniqBy([...(filter.option.data || []), ...selectedList], 'id')
      filter.option.data = optionList
      return optionList
    },
    async initCRMTagList (crmTag) {
      if (!this.hasCRMTagPermission || crmTag.hasLoad) {
        return
      }
      crmTag.hasLoad = true
      const params = {
        is_company_tag: 1,
        need_disabled: 1,
        tag_category: ['smart', 'manual'].join(',')
      }
      const resp = await this.searchTag(params)
      if (resp) {
        const tagList = _.map(resp, tag => {
          const tagInfo = tag
          tagInfo.searchTextList = [tag.name, tag.cn_name]
          addI18nProperty(tagInfo, 'i18nName', 'cn_name', 'name')
          return tagInfo
        })
        crmTag.data = this.orderTagList(tagList)
      }
      return crmTag.data
    },
    orderTagList (tagList) {
      if (isEn()) {
        return _.orderBy(tagList, ['name'], ['asc'])
      } else {
        return tagList.sort((a, b) => {
          return a.cn_name.localeCompare(b.cn_name)
        })
      }
    },
    initSelectData (itemList, page) {
      if (!itemList.data) {
        return []
      }
      itemList.page = page
      itemList.currentData = this.orderTagList(itemList.data)
      return itemList.currentData.slice(0, page * itemList.pageSize)
    },
    async searchItemList (item, keywords, loadData, valueList) {
      item.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return this.initSelectData(item, 2)
      }
      const itemList = this.orderTagList(item.data)
      const filteredList = _.filter(itemList, item => {
        if (valueList?.length > 0) {
          return _.includes(valueList, item.id)
        } else {
          const keywordsList = _.map(item.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      item.page = 1
      item.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, item.pageSize)
    },
    loadMoreData (item, filter) {
      if (item.currentData && item.page * item.pageSize > item.currentData.length) {
        return
      }
      const data = item.currentData.slice(item.page * item.pageSize, (item.page + 1) * item.pageSize)
      item.page += 1
      filter.option.data.push(...data)
    },
    async loadSearchTemplateList () {
      const resp = await this.getAccountPageConfigList({ page_type: 'UNIVERSAL_APPLICATION_LIST' })
      if (resp) {
        this.searchTemplateList = _.map(resp, pageConfig => {
          return {
            _config: pageConfig,
            id: pageConfig.id,
            name: pageConfig.config.name,
            search: pageConfig.config.search
          }
        })
      }
    },
    async initMajorList () {
      if (this.major.hasLoad) {
        return
      }
      this.major.hasLoad = true
      const resp = await this.getMajorList()
      if (!resp) {
        return
      }
      this.major.data = _.map(resp.majors, major => {
        addI18nProperty(major, 'i18nName', 'cn_name', 'name')
        major.searchTextList = [major.name, major.cn_name]
        return major
      })
      return this.major.data
    },
    async loadSalaryList () {
      const resp = await this.getSalaryList()
      if (resp) {
        this.salaryList = resp.salary_list
      }
    },
    async loadIndustryList () {
      const resp = await this.getIndustryList()
      if (resp) {
        const industryList = _.map(resp.industry_list, industry => {
          addI18nProperty(industry, 'i18nName', 'cn_name', 'name')
          industry.searchTextList = [industry.cn_name, industry.name]
          return industry
        })
        this.industryList = this.orderTagList(industryList)
      }
    },
    async getExpectedLocationList () {
      if (this.expectedLocation.hasLoad) {
        return
      }
      if (this.location.hasLoad) {
        this.expectedLocation = this.location
      } else {
        this.expectedLocation.hasLoad = true
        const resp = await this.getWorldLocationList()
        if (!resp) {
          return
        }
        this.expectedLocation.data = _.map(resp, expectedLocation => {
          addI18nProperty(expectedLocation, 'i18nName', 'cn_name', 'name')
          expectedLocation.searchTextList = [expectedLocation.name, expectedLocation.cn_name, expectedLocation.pinyin_name]
          if (expectedLocation.parent_id) {
            const locationInfo = _.find(resp, item => item.id === expectedLocation.parent_id)
            expectedLocation.parent = locationInfo
            expectedLocation.searchTextList.push(locationInfo.name, locationInfo.cn_name, locationInfo.pinyin_name)
          }

          // 处理四个直辖市, 不出现在下拉列表中
          if (_.findKey(MUNICIPALITY_CITY, city => city === expectedLocation.id)) {
            expectedLocation.searchTextList = null
          }
          if (expectedLocation.type_code === 'region') {
            expectedLocation.searchTextList = null
          }
          const nameList = []
          if (expectedLocation.parent) {
            this.getParentLocation(expectedLocation, nameList)
          }
          expectedLocation.locationName = _.chain([expectedLocation.i18nName, ...nameList]).filter().join(' - ').value()
          return expectedLocation
        })
      }
      return this.expectedLocation.data
    },
    async loadExpectedLocationList (keywords, loadData, valueList) {
      this.expectedLocation.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      if (this.expectedLocation.loader) {
        await this.expectedLocation.loader
      }
      const filteredList = _.filter(this.expectedLocation.data, expectedLocation => {
        if (valueList?.length > 0) {
          return _.includes(valueList, expectedLocation.id)
        } else {
          const keywordsList = _.map(expectedLocation.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      this.expectedLocation.page = 1
      this.expectedLocation.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, this.expectedLocation.pageSize)
    },
    async loadExpectedLocationTemplate (valueList, filter, formattedFilterValues) {
      if (valueList?.length < 1) {
        return []
      }
      const locationList = await this.loadExpectedLocationList(null, null, valueList)
      if (locationList.length > 0) {
        filter.option.data = locationList
        formattedFilterValues.expectedLocation = locationList
      }
    },
    async loadCompanyPolicyList () {
      const vm = this
      const resp = await this.getCompanyPolicyItemList()
      if (resp) {
        const sortedPolicy = _.orderBy(_.values(resp), ['created_time'], ['desc'])
        const policyList = []
        _.forEach(sortedPolicy, policy => {
          _.forEach(policy.policy_list, policyItem => {
            Object.defineProperty(policyItem, 'i18nName', {
              enumerable: true,
              configurable: true,
              get () {
                const createdTime = moment(policy.created_time).format('YYYY/MM/DD')
                const code = vm.$t(`${vm.i18nPrefix}.label.consentVersionCode`)
                const i18nContent = getI18nPropertyValue(this, 'content_cn', 'content_en')
                const i18nName = `${createdTime} ${code}: ${i18nContent}`
                return i18nName
              }
            })
            const optionList = _.map(CONSENT_STATUS, (val, key) => {
              const option = { value: `${policyItem.id}-${val}` }
              Object.defineProperty(option, 'i18nName', {
                enumerable: true,
                configurable: true,
                get () {
                  return vm.$t(`${vm.i18nPrefix}.consentStatus.${key}`)
                }
              })
              return option
            })
            policyItem.status_list = optionList
            policyList.push(policyItem)
          })
        })
        this.companyPolicyList = policyList
        return this.companyPolicyList
      }
    },
    async loadCvOwnerList () {
      const resp = await this.getCvOwnerList()
      const hrList = _.orderBy(resp.hr_list, hr => hr.name.toLowerCase(), 'asc')
      const agencyList = _.orderBy(resp.agency_list, agency => agency.name.toLowerCase(), 'asc')
      const disabledHrList = _.filter(hrList, hr => hr.is_disabled)
      const disabledAgencyList = _.filter(agencyList, agency => agency.is_disabled)
      const cvOwnerList = [
        createI18nProperty({
          children: _.filter(hrList, hr => !hr.is_disabled)
        }, 'label', `${this.i18nPrefix}.cvOwner.hr`),
        createI18nProperty({
          children: _.filter(agencyList, agency => !agency.is_disabled)
        }, 'label', `${this.i18nPrefix}.cvOwner.agency`)
      ]
      if (disabledHrList.length > 0) {
        cvOwnerList.push(createI18nProperty({ children: disabledHrList }, 'label', `${this.i18nPrefix}.cvOwner.disabledHr`))
      }
      if (disabledAgencyList.length > 0) {
        cvOwnerList.push(createI18nProperty({ children: disabledAgencyList }, 'label', `${this.i18nPrefix}.cvOwner.disabledAgency`))
      }
      this.cvOwnerList = cvOwnerList
      return this.cvOwnerList
    },
    formatCompanyData (data, company, companyList) {
      addI18nProperty(company, 'i18nName', 'cn_name', 'name')
      companyList.push(company)
      const allChildren = data.children
      const children = allChildren[company.id]
      if (children && children.length > 0) {
        for (const child of children) {
          this.formatCompanyData(data, child, companyList)
        }
      }
      return companyList
    },
    async loadCompanyList () {
      if (!this.companyListLoader) {
        this.companyListLoader = this.getCompanyChildrenTree().then(resp => {
          const currentCompany = {
            id: resp.self.id,
            name: resp.self.name,
            cn_name: resp.self.cn_name,
            level: resp.self.level
          }
          this.company = currentCompany
          const companyList = []
          this.companyList = this.formatCompanyData(resp, currentCompany, companyList)
        })
      }
      await this.companyListLoader
      return this.companyList
    },
    async loadTagList (tagCategory, tagType, tagKey, needResumeSDKTag) {
      if (!this.hasCRMTagPermission && !this.hasParseResumeTagPermission && !this.hasMicrositeCampaignPermission) {
        return
      }
      const params = {
        tag_category: tagCategory,
        tag_type: tagType
      }
      if (tagKey) {
        params.tag_key = tagKey
      }
      if (this.hasParseResumeTagPermission && needResumeSDKTag) {
        params.is_common_tag = 1
      } else {
        params.is_company_tag = 1
      }
      const resp = await this.searchTag(params)
      _.forEach(resp, tag => {
        addI18nProperty(tag, 'i18nName', 'cn_name', 'name')
        tag.searchTextList = [tag.name, tag.cn_name]
      })
      if (resp) {
        const tagList = this.orderTagList(resp)
        _.set(this.tagMap, `${tagType}${tagKey ? `.${tagKey}` : ''}`, tagList)
      }
    },
    async loadMetaIndustryList () {
      if (!this.metaIndustryListLoader) {
        this.metaIndustryListLoader = this.getMetaIndustryList().then(resp => {
          if (resp) {
            const industryList = []
            const childrenMap = {}
            _.forEach(resp, (industry) => {
              addI18nProperty(industry, 'i18nName', 'cn_name', 'name')
              industry.searchTextList = [industry.cn_name, industry.name]
              if (industry.parent_id) {
                const children = childrenMap[industry.parent_id]
                if (children) {
                  children.push(industry)
                } else {
                  childrenMap[industry.parent_id] = [industry]
                }
              } else {
                if (!childrenMap[industry.id]) {
                  childrenMap[industry.id] = []
                }
                industry.children = childrenMap[industry.id]
                industryList.push(industry)
              }
              this.metaIndustryList = this.orderTagList(industryList)
            })
          }
        })
      }
      await this.metaIndustryListLoader
      return this.metaIndustryList
    },
    async loadMetaJobFunctionList () {
      if (!this.metaJobFunctionListLoader) {
        this.metaJobFunctionListLoader = this.getMetaJobFunctionList().then(resp => {
          if (resp) {
            const jobFunctionList = _.map(resp, jobFunction => {
              jobFunction.searchTextList = [jobFunction.cn_name, jobFunction.name]
              return addI18nProperty(jobFunction, 'i18nName', 'cn_name', 'name')
            })
            this.metaJobFunctionList = this.orderTagList(jobFunctionList)
          }
        })
      }
      await this.metaJobFunctionListLoader
      return this.metaJobFunctionList
    },
    async handleCreateSearchTemplate (template, callback) {
      if (this.isSavingSearchTemplate) {
        return
      }
      this.isSavingSearchTemplate = true
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.createAccountPageConfig({
          page_type: 'UNIVERSAL_APPLICATION_LIST',
          config: {
            name: template.name,
            search: template.search
          }
        })
        if (resp) {
          const templateInfo = {
            _config: resp,
            id: resp.id,
            name: resp.config.name,
            search: resp.config.search
          }
          callback(templateInfo)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSavingSearchTemplate = false
      }
    },
    async handleUpdateSearchTemplate (template, callback) {
      if (this.isSavingSearchTemplate) {
        return
      }
      this.isSavingSearchTemplate = true
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.updateAccountPageConfig({
          id: template._config.id,
          config: {
            name: template.name,
            search: template.search
          }
        })
        if (resp) {
          const templateInfo = {
            _config: resp,
            id: resp.id,
            name: resp.config.name,
            search: resp.config.search
          }
          callback(templateInfo)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSavingSearchTemplate = false
      }
    },
    async handleClearSearchTemplate () {
      this.searchTemplate = null
    },
    async handleDeleteSearchTemplate (searchTemplate, deletedTemplateIndex) {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.deleteAccountPageConfig({
          id: searchTemplate.id
        })
        if (resp) {
          this.searchTemplateList.splice(deletedTemplateIndex, 1)
          this.$message({
            type: 'success',
            message: this.$t(`${this.i18nPrefix}.message.deleteSuccess`)
          })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async initPageData () {
      this.$eventBus.$emit('showLoading', true)
      try {
        this.getLocationList()
        this.loadSalaryList()
        this.loadIndustryList()
        await Promise.all([
          this.loadSearchTemplateList(),
          this.loadCompanyPolicyList(),
          this.loadCandidateStatusList()
        ])
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    getNoDataText (info) {
      if (!info.data || info.data.length === 0) {
        return this.$t('el.select.noData')
      } else if (info.keywords && (!info.currentData || info.currentData.length === 0)) {
        return this.$t('el.select.noMatch')
      }
      return this.$t(`${this.i18nPrefix}.label.pleaseStartTyping`)
    },
    parseSearchToParams (search) {
      const params = { order: `${this.listOrder.order === '-' ? '-' : ''}${this.listOrder.prop}` }
      const filterList = this.filterList
      _.forEach(search, (group, groupKey) => {
        if (_.includes(AI_EXTRA_PARAMS, groupKey)) {
          if (_.isArray(group)) {
            group = _.chain(group).filter().join(',').value()
          }
          params[groupKey] = group
          return
        }
        if (groupKey === 'keywords') {
          params.keywords = group
          return
        }
        if (groupKey === 'candidateName') {
          params.candidate_name = group
          return
        }
        if (groupKey === 'candidateId') {
          params.candidate_id = _.filter(group, item => item && !isNaN(item)).join(',')
          return
        }
        if (groupKey === 'employeeId') {
          params.employee_id = _.filter(group, item => item && item.trim()).join(',')
          return
        }
        const groupFilters = filterList[groupKey]
        if (groupFilters?.hidden) {
          return
        }
        const excludeFilterNames = group._exclude
        _.forEach(group, (filterValue, filterName) => {
          const filter = groupFilters?.filterList[filterName]
          if (!filter || !filterValue) {
            return
          }
          filter.setParam(params, filterValue, _.includes(excludeFilterNames, filterName))
        })
      })
      return params
    },
    async handelSearch (search, nextPage, targetPage) {
      if (nextPage) {
        if (this.pagination.page === this.pagination.totalPage) {
          this.$message.warning(this.$t(`${this.i18nPrefix}.message.noData`))
          return
        }
        this.pagination.page += 1
      } else {
        this.pagination.page = 1
      }
      this.listLoading = true
      if (!search) {
        search = this.search
      } else {
        this.search = search
      }
      const params = this.parseSearchToParams(search)
      this.searchParams = params
      const page = targetPage || this.pagination.page
      const candidateList = []
      const promiseList = _.chain(this.pagination.page).range(page + 1)
        .map((val) => {
          return this.getCompanyApplicationList({
            ...params,
            with_hm_score: this.hasInterviewPermission ? 1 : null,
            page: val,
            page_size: this.pagination.pageSize
          }).catch(resp => {
            if (resp?.code === 10001010) {
            // 忽略错误: PAGE_NO_RESULT=(10001010, 'That page contains no results'),
              return null
            }
            return Promise.reject(resp)
          })
        }).value()
      const respList = await Promise.all(promiseList)
      let totalPage = this.pagination.totalPage
      let candidateTotalCount = this.candidateTotalCount

      const loadedPages = []
      _.forEach(respList, resp => {
        if (resp) {
          loadedPages.push(resp.page)
          totalPage = resp.total_page
          candidateTotalCount = resp.total_count
          candidateList.push(...resp.data)
        }
      })
      const candidateIdSelectedMap = {}
      _.forEach(this.selectedCandidateList, item => {
        candidateIdSelectedMap[item.candidate.id] = item.selected
      })
      _.forEach(candidateList, applicant => {
        const vm = this
        const oldCandidateIsSelected = _.get(candidateIdSelectedMap, applicant.candidate.id)
        applicant.selected = oldCandidateIsSelected || false
        const candidate = applicant.candidate
        candidate.age = candidate.birthday ? moment().diff(candidate.birthday, 'year') : ''
        candidate.name = applicant.is_agency_uploaded_and_hid ? this.$t(`${this.i18nPrefix}.label.hidedCandidateName`) : candidate.name
        const hasAIInterviewScore = applicant.ai_interview_score
        const hasInterviewScore = applicant.hm_interview_total_rate
        candidate.hasFit = (this.isCoachCompany && applicant.ai_interview_info && applicant.ai_interview_info.is_finished && applicant.ai_interview_info.total_score) || (this.hasAIInterviewPermission && hasAIInterviewScore) || (this.hasAIResumeMatchPermission && applicant.ai_match_info?.resume_ai_match_score) || hasInterviewScore
        Object.defineProperty(candidate, 'maxDegreeI18nName', {
          configurable: true,
          enumerable: true,
          get () {
            const maxDegree = candidate.max_degree
            // TODO: 学历不存在的时候怎么处理，待确认
            return getConstantI18nValue(DEGREE, maxDegree, 'meta.DEGREE')
          }
        })
        Object.defineProperty(candidate, 'candidateStatusName', {
          configurable: true,
          enumerable: true,
          get () {
            let i18nKey = null
            if (candidate.is_alumni) {
              i18nKey = 'alumni'
            } else if (candidate.is_employee) {
              i18nKey = 'employee'
            } else {
              i18nKey = 'candidate'
            }
            if (!applicant.reviewed) {
              i18nKey += 'New'
            }
            return vm.$t(`${vm.i18nPrefix}.label.${i18nKey}`)
          }
        })
        Object.defineProperty(applicant, 'statusName', {
          configurable: true,
          enumerable: true,
          get () {
            return applicant.status.i18nName || getI18nPropertyValue(applicant.status, 'name_cn', 'name_en')
          },
          set (status) {
            applicant.status = status
          }
        })
        Object.defineProperty(candidate, 'aiSummaryContent', {
          configurable: true,
          enumerable: true,
          get () {
            return getI18nPropertyValue(candidate.ai_summary_info, 'ai_summary_cn', 'ai_summary_en')
          }
        })
      })
      if (this.pagination.page === 1) {
        this.candidateList = candidateList
      } else {
        this.candidateList.push(...candidateList)
      }
      this.pagination.page = _.max(loadedPages)
      this.pagination.totalPage = totalPage
      this.candidateTotalCount = candidateTotalCount
      this.listLoading = false
    },
    handleScrollBottom () {
      if (!this.listLoading) {
        this.handelSearch(this.search, true)
      }
    },
    handleOrderChange (prop, order) {
      this.listOrder.prop = prop
      this.listOrder.order = order
      this.candidateList = []
      this.handelSearch(this.search, false)
    },
    handleOpenDetail (rowData) {
      const candidateId = rowData.candidate.id
      const jobId = rowData.job.id
      rowData.reviewed = true
      const params = this.parseSearchToParams(this.search)
      const backUrl = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/profile?candidate_id=${candidateId}&job_id=${jobId}&list_params=${encodeURIComponent(JSON.stringify(params))}&page_from=applicant&back=${backUrl}`)
    },
    openDuplicateCandidateDetail (application) {
      const { candidateId, jobId } = application
      const backUrl = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/profile?candidate_id=${candidateId}&job_id=${jobId}&page_from=duplicate&back=${backUrl}`)
    },
    handleCandidateStatusClick (rowData) {
      this.handleChangeStatusOperation(rowData)
    },
    handleScrollToTop (listType) {
      this.$nextTick(() => {
        const candidateListRef = listType === 'table' ? this.$refs.tableContainer : this.$refs.cardContainer
        candidateListRef.scrollToTop && candidateListRef.scrollToTop()
      })
    },
    handleStatusChangedSuccess () {
      this.handelSearch(this.search, false, this.pagination.page)
    },
    onlyMyCandidateChange (onlyMyCandidate) {
      this.onlyMyCandidate = onlyMyCandidate
    },
    expandChange (expand, groupKey) {
      const accountConfig = this.accountConfig
      _.set(accountConfig, `${UNIVERSAL_PAGE_FILTER_KEY}.filterConfig.${groupKey}`, expand)
      this.setAccountConfig(accountConfig)
    }
  },
  watch: {
    candidateListLength () {
      if (this.isNoRefreshSelectedCandidateList) {
        return
      }
      if (this.$refs.tableContainer && (this.isSelectedAllCandidate || this.selectAllIsIndeterminate)) {
        this.$refs.tableContainer.refreshSelectAllCandidate()
      }
      if (this.$refs.cardContainer && (this.isSelectedAllCardCandidate || this.selectAllIsIndeterminate)) {
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(this.cancelSelectedCandidateList, candidate) && !candidate.is_agency_uploaded_and_hid) {
            candidate.selected = true
          } else {
            candidate.selected = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  width: 100%;
  height: 100%;

  .applicant-list {
    .last-work {
      margin-top: 6px
    }

    .filter-label {
      line-height: 20px;
      vertical-align: middle;
    }

    .filter-tip-icon {
      color: #606266;
      margin-left: 4px;
      font-size: 14px;
      line-height: 20px;
      vertical-align: top;
    }
  }

  .rate-dialog {
    ::v-deep {
      .el-dialog {
        margin: auto;

        .el-dialog__body {
          padding: 30px 30px;
        }
      }
    }
  }

  .interview-dialog {
    ::v-deep {
      .el-dialog {
        margin: auto;

        .el-dialog__body {
          padding: 30px 30px;
        }
      }
    }
  }

  .change-candidate-status-dialog {
    ::v-deep {
      .el-dialog__header {
        padding: 34px 40px 0px;
      }

      .el-dialog__body {
        padding: 0px 40px 16px;
      }

      .el-dialog__title {
        font-size: 22px;
        font-weight: 500;
        color: #303133;
      }
    }
  }
}
</style>
<style lang="scss">
.school-popper, .consent-info-popper, .company-popper {
  max-width: 300px;

  .el-select-group__title {
    padding: 0px 20px;
  }

  .label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
